(function () {
  'use strict';

  function getSubtotalCents() {
    // Prefer the live cart total attribute if present
    const el = document.querySelector('[data-cart-total]');
    if (el && el.getAttribute('data-cart-total')) {
      const v = Number(el.getAttribute('data-cart-total'));
      if (!Number.isNaN(v)) return v;
    }
    // Fallback to the initial value injected in head
    if (typeof window.theme !== 'undefined' && typeof window.theme.subtotal === 'number') {
      return window.theme.subtotal;
    }
    return 0;
  }

  function updateBars() {
    const subtotal = getSubtotalCents();
    // Only target our free-products bars which include data-tier-1
    const bars = document.querySelectorAll('[data-free-shipping][data-tier-1]');
    if (!bars.length) return;

    bars.forEach((item) => {
      const rawLimit = Number(item.getAttribute('data-free-shipping-limit')) || 0;
      const useCurrencyRate = item.getAttribute('data-use-currency-rate') !== 'false';
      // Convert to cents; respect currency rate only if explicitly enabled
      const rate = useCurrencyRate && window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate : 1;
      const limitCents = Math.max(0, rawLimit * 100 * rate);

      let percent = 0;
      if (limitCents > 0) {
        percent = (subtotal / limitCents) * 100;
        percent = Math.max(0, Math.min(percent, 100));
      }

      // Tier-1 values for snapping alignment at the exact threshold
      const tier1 = Number(item.getAttribute('data-tier-1')) || 0;
      const tier1Cents = tier1 * 100 * rate;
      const sepPercentFloat = rawLimit > 0 ? (tier1 / rawLimit) * 100 : 0;
      const isAtTier1 = Math.abs(subtotal - tier1Cents) <= 1; // within 1 cent
  // Start with matching float percent at the exact tier-1 threshold
  let percentDisplay = isAtTier1 ? Math.max(0, Math.min(sepPercentFloat, 100)) : percent;

      // Cache references
      const progressBar = item.querySelector('[data-progress-bar]');
      const progressGraph = item.querySelector('[data-progress-graph]');
      // Position the tier separator relative to the same denominator as the bar first
      const separator = item.querySelector('.progress_separator');
      if (separator && rawLimit > 0) {
        const sepLeft = Math.max(0, Math.min(sepPercentFloat, 100));
        separator.style.left = `${sepLeft}%`;
      }

      // If we're exactly at tier-1 and can measure geometry, add a tiny correction so the
      // progress end aligns with the separator's visual center (accounts for margin-left, radii, etc.)
      if (isAtTier1 && progressBar && separator) {
        const barRect = progressBar.getBoundingClientRect();
        const sepRect = separator.getBoundingClientRect();
        if (barRect.width > 0) {
          const sepCenterPx = sepRect.left + sepRect.width / 2;
          const targetPercent = ((sepCenterPx - barRect.left) / barRect.width) * 100;
          // Use the measured target percent when it looks sane; otherwise fall back
          if (!Number.isNaN(targetPercent) && targetPercent >= 0 && targetPercent <= 100) {
            percentDisplay = targetPercent;
          }
        }
      }

      // Update linear progress bar
      if (progressBar) {
        progressBar.value = percentDisplay;
      }

      // Update circular graph if present
      if (progressGraph) {
        const circumference = 28 * Math.PI; // r=7 circle in theme markup uses half offset calc
        const dashoffset = circumference - ((percentDisplay / 100) * circumference) / 2;
        progressGraph.style.setProperty('--stroke-dashoffset', `${dashoffset}`);
      }
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function bind() {
    const events = [
      'theme:cart:change',
      'theme:cart-drawer:open',
      'shopify:section:load',
      'theme:announcement:init',
      'theme:product:added',
    ];
    events.forEach((evt) => document.addEventListener(evt, updateBars));

    // Observe cart drawer updates for dynamic content changes
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const inner = drawer.querySelector('[data-cart-drawer-inner]') || drawer;
      const mo = new MutationObserver(() => updateBars());
      mo.observe(inner, { childList: true, subtree: true });
    }

    updateBars();
  }

  onReady(bind);
})();
